import { useMemo } from 'react'

import { useTheme } from '@emotion/react'

import { Color } from '@cash-web/protos/squareup/cash/ui/Color.pb'
import useMediaQuery from '@cash-web/shared-ui-use-media-query'

import '@cash-design-system/react'

import { getColorValueFromProto } from './getColorValueFromProto'

export const useColorProtoAdapter = () => {
  const { darkMode } = useTheme()
  const supportsP3 = useMediaQuery('(color-gamut: p3)')
  const prefersMoreContrast = useMediaQuery('(prefers-contrast: more)')

  return useMemo(
    () => ({
      getColorValue: (value?: Color) => getColorValueFromProto(value, { darkMode, prefersMoreContrast, supportsP3 }),
    }),
    [darkMode, prefersMoreContrast, supportsP3]
  )
}
